import axios from './axios';

/**
 * Emails API Client
 * Handles all API calls related to email tracking and history
 */
export const emailsApi = {
  /**
   * Get email history with pagination and filtering
   * @param {Object} params - Query parameters (page, limit, status, email_type, etc.)
   */
  getHistory: (params) => axios.get('/emails/history', { params }),

  /**
   * Get single email by ID
   * @param {number} id - Email ID
   */
  getById: (id) => axios.get(`/emails/${id}`),

  /**
   * Get email statistics
   * @param {Object} params - Query parameters (date_from, date_to, entity_type)
   */
  getStats: (params) => axios.get('/emails/stats', { params }),

  /**
   * Get recent emails
   * @param {number} limit - Maximum number of emails to return
   */
  getRecent: (limit = 10) => axios.get('/emails/recent', { params: { limit } }),

  /**
   * Get emails by entity (contract, trainer, etc.)
   * @param {string} entityType - Entity type (contract, trainer, etc.)
   * @param {number} entityId - Entity ID
   * @param {number} limit - Maximum number of emails to return
   */
  getByEntity: (entityType, entityId, limit = 20) => 
    axios.get(`/emails/by-entity/${entityType}/${entityId}`, { params: { limit } }),

  /**
   * Retry failed email
   * @param {number} id - Email ID to retry
   */
  retry: (id) => axios.post(`/emails/${id}/retry`),

  /**
   * Download email attachment
   * @param {number} attachmentId - Attachment ID
   * @returns {string} Download URL
   */
  downloadAttachment: (attachmentId) => {
    // Return the download URL for the attachment
    return `/api/emails/attachments/${attachmentId}/download`;
  }
};

export default emailsApi;